function toggleSolutionTab(targetId) {
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    // On mobile, hide the topic-div and show the solution-div
    document.querySelector(".topic-div").style.display = "none";
    document.querySelector(".solution-div").style.display = "block";
    document.querySelector(".solution-div").style.width = "100%";
    document.querySelectorAll(".solution-content").forEach(function (div) {
      div.style.display = "none";
    });
  } else {
    // On wider screens, just toggle the solution content
    document.querySelectorAll(".solution-content").forEach(function (div) {
      div.style.display = "none";
    });
  }

  // Show the selected solution content
  document.getElementById(targetId).style.display = "block";

  // Remove active class from all topic tabs
  document.querySelectorAll(".topic-tab").forEach(function (tab) {
    tab.classList.remove("active");
  });

  // Add active class to the clicked tab
  document
    .querySelector(`.topic-tab[data-target="${targetId}"]`)
    .classList.add("active");
}

function showTopicDiv() {
  // Show the topic-div and hide the solution-div
  document.querySelector(".topic-div").style.display = "block";
  document.querySelector(".solution-div").style.display = "none";
}

// Initial setup for topic-tab click events
document.querySelectorAll(".topic-tab").forEach(function (tab) {
  tab.addEventListener("click", function () {
    const targetId = tab.getAttribute("data-target");
    toggleSolutionTab(targetId);
  });
});

// Add click event for the back button
document.querySelector(".back-button")?.addEventListener("click", function () {
  showTopicDiv();
});

// Optional: Add a resize event listener to handle screen size changes dynamically
window.addEventListener("resize", function () {
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    if (
      document.querySelector(".topic-div") &&
      document.querySelector(".solution-div")
    ) {
      document.querySelector(".topic-div").style.display = "block";
      document.querySelector(".solution-div").style.display = "none";
    }
  } else {
    // Ensure the solution-div is displayed correctly on wider screens
    if (document.querySelector(".solution-div")) {
      document.querySelector(".solution-div").style.display = "block";
    }
  }
});
